App.addModule(function(app) {

    if (!app.getConfigFlag('google/analytics/active') || !app.get('customer.can_track')) {
        return
    }
    
    const convertProductToItem = function(product, category_path) {

	    const item = {
		    item_id: product.sku,
		    item_name: '['+ product.sku +'] ' + product.name,
		    item_variant: product.option_sku || null,
		    item_brand: product.serie || null,
		    price: app.round(product.base_price, 2),
            availability: product.is_in_stock && 'In Stock' || 'Out Of Stock',
	        product_type: product.product_type || null
	    }
        
        category_path = category_path || product.category_path || false

        if (category_path) {

            let index = 1

            category_path.split('/').forEach(category => {
                item['item_category'+ (index == 1 ? '' : index).toString()] = category
                ++index
            })
        }

        return item
    }
    
    const convertCartItemToItem = function(cart_item) {
	    
	    const item = convertProductToItem(cart_item.product, cart_item.category_path)
	    
	    item.price = app.round(cart_item.base_price, 2)
	    item.quantity = cart_item.qty
	    
	    return item
    }
    
    const convertOrderItemToItem = function(order_item) {
	    
        const item = convertProductToItem(order_item.product, order_item.category_path)
        
	    item.price = app.round(order_item.base_price, 2)
	    item.quantity = order_item.qty_ordered
	    
	    return item
    }

    const event = function(name, params = {}) {

        params.timestamp = (new Date()).toISOString()
        
        gtag('event', name, params)
        
        if (app.get('app.is_developer_mode')) {
            console.log('gtag', name, params)
        }
    }
    

    window.dataLayer = window.dataLayer || []

    window.gtag = function(){dataLayer.push(arguments)}

    const currency = app.get('app.store.base_currency_code')
    
    gtag('set', {
        currency: currency,
        content_group: app.get('app.page_type', '(not set)'),
        has_cart: app.get('checkout.cart.items_count') > 0 && 'Yes' || 'No',
        cart_total: app.round(app.get('checkout.cart.base_subtotal'), 2),
        debug_mode: app.get('app.is_developer_mode')
    })

    const currentProduct = app.get('current_product')
    
    if (currentProduct) {
        
        const item = convertProductToItem(currentProduct)
        
        event('view_item', {
	        items: [item],
	        value: app.round(currentProduct.base_price, 2),
	        currency: currency
        })
    }

    const order = app.get('checkout.order')
    
    if (order) {
        
        const items = []
        
        Object.values(order.items).forEach(item => {
            items.push(convertOrderItemToItem(item))
        })
        
        event('purchase', {
            transaction_id: order.increment_id,
            affiliation:  app.get('app.store.code'),
            value: app.round(order.base_subtotal, 2),
            currency: order.base_currency_code,
            tax: app.round(order.base_tax_amount, 2),
            shipping: app.round(order.base_shipping_amount, 2),
            items: items,
            new_customer: order.is_customer ? 'no' : 'yes',
            email: order.customer_email,
            phone: order.billing_address.telephone,
            firstname: order.billing_address.firstname,
            lastname: order.billing_address.lastname,
            street: order.billing_address.street1,
            zip: order.billing_address.postcode,
            city: order.billing_address.city,
            country: order.billing_address.country_id
        })
    }

    app.on('loaded', () => {
        
        Object.values(app.get('catalog.product.lists', {})).forEach(list => {
          
            const items = []
            
            let index = 1 + list.page_size * (list.page - 1)
            
            Object.values(list.products).forEach(product => {
            
                const item = convertProductToItem(product)
                
                item.item_list_id = list.type
                item.item_list_name = list.title
                item.index = index++
                
                items.push(item)
                
                const el = document.getElementById(list.type + '-product-' + product.sku)
                
                el && el.addEventListener('click', () => {

                    event('select_item', {
                        items: [item],
                        item_list_id: list.type,
                        item_list_name: list.title
                    })
                })
            
                const el2 = document.getElementById(list.type + '-scroll-product-' + product.sku)

                el2 && el2.addEventListener('click', () => {

                    event('select_item', {
                        items: [item],
                        item_list_id: list.type,
                        item_list_name: list.title
                    })
                })
            })

            event('view_item_list', {
                items: items,
                item_list_id: list.type,
                item_list_name: list.title,
                currency: currency
            })
        })
    })

    app.on('alert', alert => {

        if (alert.level == 'danger') {

            event('site:page_error', {
                error_message: alert.message,
                non_interaction: true
            })
        }
    })

    app.on('cart:update', (item, qty) => {
        
        const ga4item = convertCartItemToItem(item),
                value = ga4item.price * item.qty
        
        ga4item.quantity = item.qty
        
        if (qty > 0) {
            event('add_to_cart', {
	            items: [ga4item],
                currency: currency,
                value: app.round(value, 2)
            })
        }
        else {
            event('remove_from_cart', {
	            items: [ga4item],
                currency: currency,
                value: app.round(value, 2)
            })
        }
    })

    /*
     * Cart
     */
    if (app.get('app.request.path') === 'checkout/cart/index') {
        
        const items = []
        
        Object.values(app.get('checkout.cart.items')).forEach(item => {
	        items.push(convertCartItemToItem(item))

        })
        
        event('view_cart', {
	        items: items,
	        currency: currency,
	        value: app.round(app.get('checkout.cart.base_subtotal'), 2)
        })
        
        app.on('coupon:apply', code => {
            event('site:cart_applyCoupon', {coupon_code: code})
        })

        app.on('coupon:remove', () => {
            event('site:cart_removeCoupon')
        })
    }

    /*
     * Checkout
     */
    if (app.get('app.request.path') === 'erp/checkout/index') {

        const items = []
        
        Object.values(app.get('checkout.cart.items')).forEach(item => {
	        items.push(convertCartItemToItem(item))
        })
        
        value = app.round(app.get('checkout.cart.base_subtotal'), 2)
        
        event('begin_checkout', {
	        items: items,
	        currency: currency,
	        value: value
        })
        
        app.on('checkout:setShippingMethod', method => {
	        event('add_shipping_info', {
		        shipping_tier: method,
		        items: items,
		        currency: currency,
		        value: value
	        })
        })
        
        app.on('checkout:setPaymentMethod', method => {
            
	        event('add_payment_info', {
		        payment_type: method,
		        items: items,
		        currency: currency,
		        value: value
	        })
        })
        
        app.on('checkout:placeOrderError', (msg, field) => {
	        
	        if (!field) {
                event('site:checkout_error', {
	                error_message: msg,
	                non_interaction: true
                })
	        }
        })

        app.on('klarna:authApproved', method => {
            event('site:checkout_klarnaApproved', {label: method})
        })

        app.on('klarna:authFailed', method => {
            event('site:checkout_klarnaFailed', {label: method})
        })
    }
})
